import { createTheme } from "@mui/material/styles";
import { lightTheme } from "@asi/design-tokens";

/**
 * Thin MUI base theme — brand primaries from @asi/design-tokens (light).
 * Prefer appLightTheme / appDarkTheme via AppThemeShell for runtime UI.
 */
export const muiTheme = createTheme({
  palette: {
    primary: {
      main: lightTheme.colors.primary,
    },
    secondary: {
      main: lightTheme.colors.secondary,
    },
  },
  components: {
    MuiButton: {
      defaultProps: {
        variant: "text",
      },
    },
    MuiCard: {
      defaultProps: {
        variant: "outlined",
      },
    },
    MuiSelect: {
      defaultProps: {
        variant: "outlined",
      },
    },
    MuiTextField: {
      defaultProps: {
        variant: "outlined",
      },
    },
  },
  typography: {
    h1: {
      fontFamily: lightTheme.fonts.display,
    },
    h2: {
      fontFamily: lightTheme.fonts.display,
    },
    h3: {
      fontFamily: lightTheme.fonts.display,
    },
    h4: {
      fontFamily: lightTheme.fonts.display,
    },
    h5: {
      fontFamily: lightTheme.fonts.display,
    },
  },
});
